<app-product-common-listing *ngIf="favouriteProducts.length > 0" [products]="favouriteProducts"></app-product-common-listing>
<span *ngIf="favouriteProducts.length === 0">Nincs egy termék sem hozzáadva a kedvencekhez.</span>
